import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoTrazaService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerDocumento(
    inputParams: {
      empresa_rut: number;
      tipo_dte_codigo: number;
      folio: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $tipo_dte_codigo: Decimal, $folio: Decimal) {
            documento_traza {
              obtenerDocumento(empresa_rut: $empresa_rut, tipo_dte_codigo: $tipo_dte_codigo, folio: $folio) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  documento {
                    folio
                    fecha_emision
                    rut_emisor
                    nombre_emisor
                    direccion_nombre
                    rut_receptor
                    nombre_receptor
                    monto_total
                  }
                  eventos {
                    fecha_evento
                    evento_nombre
                    observacion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_traza.obtenerDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }
}
